import type { FrameDrawing } from "../types";

export type RevisionDraft = { tc: number; text: string; drawing?: FrameDrawing };

/** Keep frame annotations when a UI draft becomes a server/store payload. */
export const revisionDraftPayloads = (drafts: RevisionDraft[]): RevisionDraft[] =>
  drafts.map(({ tc, text, drawing }) => ({ tc, text, drawing }));
